module.exports = __webpack_public_path__ + "img/10.ed1d9b0e.png";